import { ConfigType, EnvConfigType, CommonConfigType } from './ConfigType';
import configLocal from './config-local';
import configDev from './config-dev';
import configPrd from './config-prd';
import configStg from './config-stg';
import configSub from './config-sub';
import configTst from './config-tst';

const envConfigs: Record<string, EnvConfigType> = {
  local: configLocal,
  dev: configDev,
  prd: configPrd,
  stg: configStg,
  sub: configSub,
  tst: configTst,
};

const env = process.env.VUE_APP_ENV ?? 'local';

const envConfig: EnvConfigType = envConfigs[env] ?? configLocal;

// 環境で変わらない設定をこちらに追加してください。
// ConfigTypeの変更も必要です。
const commonConfig: CommonConfigType = {
  startDatePickerBuffer: 7,
  encodeTargetProperties: ['password', 'oldPassword', 'newPassword'],
  termOfServiceChildrenUrl: '/oyakusoku', // おやくそく
  termOfServiceUrl: '/agreement', // 団体利用規約
  aboutAbjUrl: '/abj', // ABJマークについて
  privacyPolicyUrl: 'https://www.poplar.co.jp/privacyPolicy/index.html', // プライバシーポリシー
  websiteAgreementUrl: 'https://www.poplar.co.jp/agreement/index.html',
  landingPageUrl: 'https://www.poplar.co.jp/',
  allowedIdleMinutes: 60,
  pollingInterval: 5 * 1000, //ポーリング秒数
  mottoSokkaSupport: 'https://cs-mottosokka.poplar.co.jp/supportpage_top', // mottoSokkaサポート
  mottoSokkaSupportForTeacher: 'https://cs-mottosokka.poplar.co.jp/guide', // 【先生向け】使い方動画・活用ツール
  mottoSokkaSupportForLibrary:
    'https://api01-platform.stream.co.jp/apiservice/plt3/ODA2Nw%3d%3d%23NTA5%23280%23168%230%233FE6A059E400%23MDoyOjc6YTpmOzEwOzEwOzEw%23',
  gigaschoolSupportTop: 'https://cs-mottosokka.poplar.co.jp/nextgiga_supportpage_top',
};

// 共通設定と環境設定をマージします。
// 同じ設定が両方にある場合、環境設定が優先されます。
const config: ConfigType = { ...commonConfig, ...envConfig };

export default config;
